import clsx from 'clsx'

interface DefaultLayoutProps {
  children: React.ReactNode
  className?: string
}

export default function DefaultLayout({ className, children }: DefaultLayoutProps) {
  return <div className={clsx(className, 'h-full w-full min-h-dvh')}>{children}</div>
}
